export function getSize() {
  const screenHeight = window.innerHeight;
  let screenWidth = window.innerWidth;
  
  // Use document.documentElement.clientWidth as fallback - it excludes scrollbar
  // and is more reliable on some mobile browsers
  const clientWidth = document.documentElement?.clientWidth || screenWidth;
  screenWidth = Math.min(screenWidth, clientWidth);
  
  let boardSize;
  const isDesktop = screenWidth > 768;
  if (isDesktop) {
    const adSize = 160; //showAd ? (screenWidth < 1025 ? 160 : 160) : 0;
    boardSize = Math.min(
      Math.round(screenHeight - 150),
      screenWidth - 400 - adSize
    );

    if (boardSize > 704) {
      boardSize = 704;
    } else if (boardSize < 420) {
      boardSize = 420;
    } else {
      boardSize -= boardSize % 8;
    }
  } else {
    // On mobile, ensure board fits within viewport
    // Use the smaller of innerWidth and clientWidth, minus a small buffer for safety
    screenWidth = Math.min(screenWidth, clientWidth);
    screenWidth -= screenWidth % 2;
    boardSize = screenWidth;
  }
  return { boardSize, isDesktop, height: screenHeight };
}
